export type RouteDefinition = {
	path: string;
	createPath?: (props: any) => string;
};

export const RoutesConfig = {
	home: {
		path: "/"
	},
	chat: {
		path: "/chat"
	},
	chatId: {
		path: "/chat/[...id]",
		createPath: (props: { id: string }) => `/chat/${props.id}`
	},
	signIn: {
		path: "/sign-in"
	},
	signUp: {
		path: "/sign-up"
	},
	onboarding: {
		path: "/onboarding"
	}
} as const satisfies Record<string, RouteDefinition>;

export const PrivatePages = [RoutesConfig.chat.path] as string[];
